import { FC, MouseEvent } from "react"
import MUIModal, { ModalProps as MUIModalProps } from "@mui/material/Modal"
import { Icon, IconColor } from "@/components/shared/Icon"
import "./index.scss"

interface ModalProps extends MUIModalProps {
   handleClose: (e: MouseEvent) => void
   hideCloseIcon?: boolean
}

const Modal: FC<ModalProps> = ({
   children,
   open,
   handleClose,
   hideCloseIcon = false,
}) => {
   return (
      <MUIModal
         className="modal"
         open={open}
         onClose={hideCloseIcon ? undefined : handleClose}
      >
         <div className="modal__content">
            {!hideCloseIcon && (
               <div className="modal__header">
                  <Icon
                     color={IconColor.COOL_GRAY}
                     className="modal__close"
                     name="cross"
                     onClick={handleClose}
                  />
               </div>
            )}
            {children}
         </div>
      </MUIModal>
   )
}

export default Modal
